// Calendly popup widget loader (lazy-injected on first use).
// Docs: https://help.calendly.com/hc/en-us/articles/223147027

const CSS_URL = "https://assets.calendly.com/assets/external/widget.css";
const JS_URL = "https://assets.calendly.com/assets/external/widget.js";
const CALENDLY_URL = "https://calendly.com/kevinnwisener/30min";

let loadingPromise = null;

function loadCalendly() {
  if (typeof window === "undefined") return Promise.reject(new Error("SSR"));
  if (window.Calendly) return Promise.resolve(window.Calendly);
  if (loadingPromise) return loadingPromise;

  loadingPromise = new Promise((resolve, reject) => {
    // CSS
    if (!document.querySelector(`link[href="${CSS_URL}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = CSS_URL;
      document.head.appendChild(link);
    }
    // JS
    const existing = document.querySelector(`script[src="${JS_URL}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(window.Calendly));
      existing.addEventListener("error", reject);
      return;
    }
    const script = document.createElement("script");
    script.src = JS_URL;
    script.async = true;
    script.onload = () => resolve(window.Calendly);
    script.onerror = reject;
    document.body.appendChild(script);
  });

  return loadingPromise;
}

export function openCalendly(prefill = {}) {
  loadCalendly()
    .then((Calendly) => {
      if (!Calendly) return;
      Calendly.initPopupWidget({
        url: CALENDLY_URL,
        prefill: {
          name: prefill.name,
          email: prefill.email,
          customAnswers: prefill.customAnswers,
        },
      });
    })
    .catch((e) => {
      // Fallback: open Calendly in a new tab
      console.error("Calendly failed to load:", e);
      window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
    });
}

export { CALENDLY_URL };
